document.addEventListener('DOMContentLoaded', () => {
  const initNobleStoriesSlider = () => {
    const swiperContainers = document.querySelectorAll('.noble-stories__slider');

    swiperContainers.forEach(container => {
      if (!container.parentElement) return;

      // Check if swiper is already initialized
      // @ts-ignore
      if (container.swiper) return;

      // @ts-ignore
      const swiper = new Swiper(container, {
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        spaceBetween: 0,
        grabCursor: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        pagination: {
          el: container.parentElement.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    });
  };

  initNobleStoriesSlider();

  // Re-init on section load in theme editor
  document.addEventListener('shopify:section:load', (e) => {
    const target = /** @type {HTMLElement} */ (e.target);
    if (target && target.querySelector('.noble-stories__slider')) {
      initNobleStoriesSlider();
    }
  });
});
